module.exports = __webpack_public_path__ + "media/images/ui__textArrowUpLight--dark-631f602ceaf21720d942b8fe4415dec7.png";